
interface OrderSummaryCardProps {
  subtotal: number;
  shippingCost: number;
  tax: number;
  discount: number;
  total: number;
}

export default function OrderSummaryCard({
  subtotal,
  shippingCost,
  tax,
  discount,
  total,
}: OrderSummaryCardProps) {
  return (
    <div className="bg-white border border-gray-100 rounded-xl p-6">
      <h3 className="text-sm font-semibold text-gray-900 tracking-wider mb-4">
        PAYMENT SUMMARY
      </h3>
      <div className="space-y-3 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-500">Subtotal</span>
          <span className="text-gray-900">${subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Shipping</span>
          <span className="text-gray-900">
            {shippingCost === 0 ? 'FREE' : `$${shippingCost.toFixed(2)}`}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Tax</span>
          <span className="text-gray-900">${tax.toFixed(2)}</span>
        </div>
        {discount > 0 && (
          <div className="flex justify-between">
            <span className="text-gray-500">Discount</span>
            <span className="text-[#2E7D32] font-medium">-${discount.toFixed(2)}</span>
          </div>
        )}
        <div className="border-t border-gray-100 pt-3 mt-3">
          <div className="flex justify-between items-center">
            <span className="text-base font-semibold text-gray-900">Total Paid</span>
            <span className="text-xl font-serif font-bold text-[#2E7D32]">
              ${total.toFixed(2)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
